<template>
  <v-content>
    <div :class="{ 'core-view': $route.name !== 'Landing' }">
      <!-- <div :class="{ 'core-view': $route.name !== 'Landing' && $route.name !== 'Maintenance' }"> -->
      <v-fade-transition mode="out-in">
        <router-view/>
      </v-fade-transition>
    </div>
    <core-footer v-if="$route.name !== 'Landing'"/>
    <!-- <core-footer v-if="$route.name !== 'Maintenance'"/> -->
  </v-content>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "EverOwl Technologies"
    };
  }
};
</script>

<style>
.core-view {
  padding-bottom: 80px;
}
</style>
